<template>
    <div>
        <div class="loading" v-if="$store.state.loading_state">
            <div class='loading_main'>
                <img src="@/assets/image/public/icon_loading.gif">
                <div class="loading_text">{{$store.state.loading_text}}</div>
            </div>
        </div>
        <router-view />

    </div>
</template>

<style lang="less">
    @import '@/assets/css/app.less';

    .loading {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.3);
        z-index: 9999999999;
        display: flex;
        justify-content: center;
        align-content: center;
    }

    .loading_main {
        position: absolute;
        top: 50%;
        text-align: center;
        margin-top: -22.5px;
    }

    .loading .loading_main img {
        width: 110px;
    }

    .loading .loading_main .loading_text {
        color: #ffffff;
        font-size: 13px;
        margin-top: 5px;
    }
</style>